import React from 'react';
import { Space, Typography } from 'antd';
import { JourneyState } from 'interfaces/journey';
import { useSetJourneyName } from 'services/journeys';
import { useJourneyDashboardContext } from '../context';

const { Text } = Typography;

const MAX_NAME = 60;

const JourneyName: React.FC = () => {
  const { id, name, state } = useJourneyDashboardContext();
  const { mutate: rename } = useSetJourneyName();
  if (!id) return null;

  const editable = state === JourneyState.Draft;
  return (
    <Space size={8}>
      <Text strong>{id}</Text>
      {(editable || name) && (
        <Text
          className="journey-name"
          strong={!!name}
          type={name ? undefined : 'secondary'}
          editable={
            editable && {
              text: name ?? '',
              maxLength: MAX_NAME,
              tooltip: 'Cambiar el nombre',
              onChange: (value) => {
                if (value.trim() !== (name ?? ''))
                  rename({ journeyId: id, name: value });
              },
            }
          }
        >
          {name || 'Sin nombre'}
        </Text>
      )}
    </Space>
  );
};

export default JourneyName;
